module.exports = "fragment Amount on Amount {\n  __typename\n  amount\n  currency\n  description\n}\n"